export default "__VITE_ASSET__p4a0GN3p__"